module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-Light.7cce27d.eot";